/**
 * 路径前缀到模块菜单权限。更长的前缀必须写在前面。
 */
const ROUTE_PERMISSIONS: { prefix: string; permission: string | string[] }[] = [
  { prefix: '/product/long-rent-platform', permission: 'LONG_RENT_PLATFORM_PRODUCT_MANAGE' },
  { prefix: '/product/long-rent-merchant', permission: 'LONG_RENT_MERCHANT_PRODUCT_MANAGE' },
  { prefix: '/product/platform', permission: 'PLATFORM_PRODUCT_MANAGE' },
  { prefix: '/product/jd', permission: 'JD_PRODUCT_MANAGE' },
  { prefix: '/product/merchant', permission: 'MERCHANT_PRODUCT_MANAGE' },
  { prefix: '/product/offline', permission: 'OFFLINE_PRODUCT_MANAGE' },
  { prefix: '/product/category', permission: 'CATEGORY_MANAGE' },
  { prefix: '/product/brand', permission: 'BRAND_MANAGE' },
  { prefix: '/product/tag', permission: 'TAG_MANAGE' },
  { prefix: '/product/productModel', permission: 'PRODUCT_MODEL_MANAGE' },
  { prefix: '/product/model-enrollment-admin', permission: 'MODEL_ENROLLMENT_ADMIN_MANAGE' },
  { prefix: '/product/model-enrollment', permission: 'MODEL_ENROLLMENT_MANAGE' },
  { prefix: '/product/specification', permission: 'SPECIFICATION_MANAGE' },
  { prefix: '/product/image/upload', permission: ['PRODUCT_CREATE', 'PLATFORM_PRODUCT_CREATE', 'LONG_RENT_MERCHANT_PRODUCT_CREATE', 'LONG_RENT_PLATFORM_PRODUCT_CREATE'] },
  { prefix: '/product/new', permission: 'PRODUCT_MANAGE' },
  { prefix: '/product', permission: 'PRODUCT_MANAGE' },
  { prefix: '/meituan-product/upload', permission: 'MEITUAN_PRODUCT_CREATE' },
  { prefix: '/meituan-product', permission: 'MEITUAN_PRODUCT_MANAGE' },
  { prefix: '/order/aftersalelist', permission: 'AFTER_SALE_MANAGE' },
  { prefix: '/order/complaint', permission: 'COMPLAINT_MANAGE' },
  { prefix: '/order/meituan-statistics', permission: 'MEITUAN_ORDER_MANAGE' },
  { prefix: '/order/meituan', permission: 'MEITUAN_ORDER_MANAGE' },
  { prefix: '/order/jd-statistics', permission: 'JD_ORDER_MANAGE' },
  { prefix: '/order/jd', permission: 'JD_ORDER_MANAGE' },
  { prefix: '/order/offline', permission: 'OFFLINE_ORDER_MANAGE' },
  { prefix: '/order/long-rent', permission: 'LONG_RENT_ORDER_MANAGE' },
  { prefix: '/order/buyout', permission: ['ORDER_MANAGE', 'LONG_RENT_ORDER_MANAGE'] },
  { prefix: '/order', permission: 'ORDER_MANAGE' },
  { prefix: '/risk-control/sms-send-records', permission: 'SMS_RECORD_MANAGE' },
  { prefix: '/risk-control', permission: 'RISK_REPORT_MANAGE' },
  { prefix: '/finance/offline-settlement', permission: 'OFFLINE_SETTLEMENT_MANAGE' },
  { prefix: '/finance/settlement', permission: 'SETTLEMENT_MANAGE' },
  { prefix: '/finance/revenue', permission: 'REVENUE_MANAGE' },
  { prefix: '/finance/deposit', permission: 'DEPOSIT_MANAGE' },
  { prefix: '/voucher/marketing', permission: 'VOUCHER_MANAGE' },
  { prefix: '/voucher', permission: 'VOUCHER_ACTIVITY_MANAGE' },
  { prefix: '/recycle/categories', permission: 'RECYCLE_CATEGORY_MANAGE' },
  { prefix: '/recycle/orders', permission: 'RECYCLE_ORDER_MANAGE' },
  { prefix: '/recycle/valuations', permission: 'RECYCLE_VALUATION_MANAGE' },
  { prefix: '/recycle/qualifications', permission: 'RECYCLE_QUALIFICATION_MANAGE' },
  { prefix: '/merchant-lead', permission: 'MERCHANT_LEAD_MANAGE' },
  { prefix: '/alipay-subject', permission: 'ALIPAY_SUBJECT_MANAGE' },
  { prefix: '/dashboard', permission: 'DASHBOARD_MANAGE' },
  { prefix: '/user', permission: 'SYS_USER_MANAGE' },
  { prefix: '/role', permission: 'SYS_ROLE_MANAGE' },
  { prefix: '/permission', permission: 'PERMISSION_MANAGE' },
  { prefix: '/page', permission: 'HOME_MODULE_MANAGE' },
  { prefix: '/points', permission: 'POINTS_MANAGE' },
  { prefix: '/member', permission: 'APP_USER_MANAGE' },
  { prefix: '/merchant', permission: 'MERCHANT_MANAGE' },
  { prefix: '/store', permission: 'STORE_MANAGE' },
  { prefix: '/tweet', permission: 'TWEET_MANAGE' },
];

export function permissionForPath(pathname: string): string | string[] | undefined {
  const matched = ROUTE_PERMISSIONS.find(
    (item) => pathname === item.prefix || pathname.startsWith(`${item.prefix}/`)
  );
  return matched?.permission;
}
